// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconBug,
    IconLayoutDashboard,
    IconUsers,
    IconBox,
    IconTrademark,
    IconWifi,
    IconReportAnalytics,
    IconTicket,
    IconSettings
} from '@tabler/icons';

// constant
const icons = {
    IconBug,
    IconLayoutDashboard,
    IconUsers,
    IconBox,
    IconTrademark,
    IconWifi,
    IconReportAnalytics,
    IconTicket,
    IconSettings
};

// ==============================|| ADMIN PAGES MENU ITEMS ||============================== //

const adminPages = {
    id: 'adminPages',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: <FormattedMessage id="dashboard" />,
            type: 'item',
            icon: icons.IconLayoutDashboard,
            url: '/dashboard'
        },
        {
            id: 'customers',
            title: <FormattedMessage id="customers" />,
            type: 'item',
            icon: icons.IconUsers,
            url: '/customers'
        },
        {
            id: 'chillers',
            title: <FormattedMessage id="chillers" />,
            type: 'item',
            icon: icons.IconBox,
            url: '/chillers'
        },
        {
            id: 'trademark',
            title: <FormattedMessage id="trademark" />,
            type: 'item',
            icon: icons.IconTrademark,
            url: '/trademark'
        },
        {
            id: 'users',
            title: <FormattedMessage id="users" />,
            type: 'item',
            icon: icons.IconUsers,
            url: '/users'
        },
        {
            id: 'tickets',
            title: <FormattedMessage id="tickets" />,
            type: 'item',
            icon: icons.IconTicket,
            url: '/tickets'
        },
        {
            id: 'statistics',
            title: <FormattedMessage id="statistics" />,
            type: 'item',
            icon: icons.IconReportAnalytics,
            url: '/statistics'
        },
        {
            id: 'area-covered',
            title: <FormattedMessage id="area-covered" />,
            type: 'item',
            icon: icons.IconWifi,
            url: '/area-covered'
        },
        {
            id: 'userSetting',
            title: <FormattedMessage id="userSetting" />,
            type: 'collapse',
            icon: icons.IconSettings,
            children: [
                {
                    id: 'profile',
                    title: <FormattedMessage id="profile" />,
                    type: 'item',
                    url: '/profile'
                }
            ]
        }
    ]
};

export default adminPages;
